import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem } from '../../../__styling'

const { neutral } = tokens.thenightly.colors.palette

export const StyledParentContainer = styled.div(({ theme }) => ({
    padding: `${calcRem(theme.margins.md)} 0 0 0`,
}))

export const StyledLatestLiveBlogMilestonesContainer = styled.div(
    ({ theme }) => ({
        backgroundColor: neutral[10],
        display: 'flex',
        flexDirection: 'column',
        padding: calcRem(theme.margins.md),
        borderRadius: calcRem(12),
    }),
)

export const StyledRow = styled.div({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    padding: '0',
    minHeight: calcRem(40),
})

export const StyledBulletContainer = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    paddingRight: calcRem(theme.margins.sm),
    alignItems: 'center',
    minWidth: calcRem(12),
}))

export const StyledBulletCircle = styled.div(({ theme }) => ({
    width: calcRem(4),
    height: calcRem(4),
    borderRadius: 999,
    backgroundColor: neutral[70],
    marginTop: theme.margins.sm,
}))

export const StyledVerticalLine = styled.div(({ theme }) => ({
    width: calcRem(1),
    flex: 1,
    backgroundColor: neutral[20],
    marginTop: calcRem(6),
}))

export const StyledTextContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
})

export const StyledDate = styled.p(() => ({
    color: neutral[60],
    padding: 0,
    margin: 0,
}))

export const StyledDescription = styled.p(({ theme }) => ({
    color: neutral[100],
    fontSize: calcRem(16),
    lineHeight: '150%',
    fontFamily: theme.fonts.sansSerif,
    padding: 0,
    margin: 0,
    paddingBottom: calcRem(theme.margins.md),
    '&:hover': {
        textDecoration: 'underline',
    },
}))

export const StyledTitle = styled.p(({ theme }) => ({
    color: neutral[100],
    fontWeight: 800,
    fontSize: calcRem(20),
    fontFamily: theme.fonts.sansSerif,
    lineHeight: calcRem(24),
    padding: 0,
    margin: 0,
    paddingBottom: calcRem(theme.margins.md),
}))
